import { render, staticRenderFns } from "./TeamMemberSmall.vue?vue&type=template&id=687da3cf"
import script from "./TeamMemberSmall.vue?vue&type=script&lang=js"
export * from "./TeamMemberSmall.vue?vue&type=script&lang=js"
import style0 from "./TeamMemberSmall.vue?vue&type=style&index=0&id=687da3cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports